var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('CkEditorFormGroup',{attrs:{"value":_vm.value.content,"name":"content","label":"Content","error":(_vm.errors.content || [])[0]},on:{"input":function($event){return _vm.emit('content', $event)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }